const lazyLoad = {
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), {
        once: true,
      });
      return;
    }

    const imgsLazy = document.querySelectorAll<HTMLElement>(
      '.jsLazy[data-img][data-loaded="false"]',
    );

    // IntersectionObserver for modern browsers
    if (typeof IntersectionObserver !== "undefined") {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.addImg(entry.target as HTMLElement);
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: "300px 0px",
          threshold: 0,
        },
      );

      imgsLazy.forEach((item) => {
        observer.observe(item);
      });
    } else {
      // Fallback for older browsers
      const checkImages = () => {
        imgsLazy.forEach((item) => {
          if (item.dataset.loaded !== "false") return;

          const rect = item.getBoundingClientRect();

          if (
            rect.top <= window.innerHeight + 300 &&
            rect.bottom >= -300 &&
            rect.width > 0 &&
            rect.height > 0
          ) {
            this.addImg(item);
          }
        });

        const remaining = Array.from(imgsLazy).some(
          (item) => item.dataset.loaded === "false",
        );

        if (!remaining) {
          window.removeEventListener("scroll", checkImages);
          window.removeEventListener("resize", checkImages);
        }
      };

      window.addEventListener("scroll", checkImages, {
        passive: true,
      });

      window.addEventListener("resize", checkImages);

      checkImages();
    }

    // Preserve existing jsDomLoaded behavior
    const loadDomImages = () => {
      document
        .querySelectorAll<HTMLElement>(
          '.jsDomLoaded[data-img][data-loaded="false"]',
        )
        .forEach((item) => {
          this.addImg(item);
        });
    };

    if (document.readyState === "complete") {
      loadDomImages();
    } else {
      window.addEventListener("load", loadDomImages, {
        once: true,
      });
    }
  },

  addImg(item: HTMLElement) {
    const img = item.dataset.img;

    if (!img || item.dataset.loaded !== "false") return;

    item.style.backgroundImage = `url("${img}")`;
    item.dataset.loaded = "true";
  },
};

export default lazyLoad;
